const BrandTitle = () => {
    return (
        <a className="brand d-inline-flex align-items-center justify-content-center" href="/">
            <img src={require("../../../../Images/Bikal Binod Adhikari Logo.png")} className="brandLogo"/>
              </a>
    )
}
export default BrandTitle;